import getReclameAquiClassificationTextColor from "components/company/reclameaqui/getReclameAquiClassificationTextColor";
import ReclameAquiIcon from "components/icons/ReclameAquiIcon";
import format from "date-fns/format";
import lightFormat from "date-fns/lightFormat";
import enUS from "date-fns/locale/en-US";
import ptBR from "date-fns/locale/pt-BR";
import type { IAmericanCompanyIssuerTopLevelFragment } from "lib/fragments/__generated__/AmericanCompanyIssuerTopLevel.generated";
import type { IBrazilianCompanyIssuerTopLevelFragment } from "lib/fragments/__generated__/BrazilianCompanyIssuerTopLevel.generated";
import parseDateYmd from "lib/utils/parseDateYmd";

interface ICompanyIssuerRatingsProps {
  issuer: IBrazilianCompanyIssuerTopLevelFragment | IAmericanCompanyIssuerTopLevelFragment;
}

function CompanyIssuerRatings({ issuer }: ICompanyIssuerRatingsProps) {
  const isBrazilianIssuer = issuer.__typename === "BrazilianCompanyIssuer";

  if (isBrazilianIssuer && issuer.reclameAquiRatings) {
    return (
      <div className="space-y-4">
        <div className="space-y-4 rounded-xl p-2 py-0 font-aeonik">
          <div className="flex items-center space-x-2">
            <div className="flex h-12 w-12 items-center justify-center rounded-full bg-green-50 squircle">
              <ReclameAquiIcon className="h-7 w-7" />
            </div>

            <div>
              <h4 className="text-lg font-bold text-emerald-700">Reclame Aqui</h4>
              <a
                className="text-sm font-medium italic text-gray-500 hover:underline"
                href={issuer.reclameAquiUrl}
                rel="noopener noreferrer"
                target="_blank"
              >
                Avaliação dos Consumidores
              </a>
            </div>
          </div>

          <div className="space-y-2 px-2">
            <div>
              <div className="space-x-2">
                <span className="text-2xl font-bold text-gray-700">{issuer.reclameAquiRatings.finalScore} / 10</span>

                <span
                  className="text-sm font-bold"
                  style={{
                    color: getReclameAquiClassificationTextColor(issuer.reclameAquiRatings.finalScore),
                  }}
                >
                  {issuer.reclameAquiRatings.classification}
                </span>
              </div>
            </div>

            <div>
              <RatingsAsOfDate asOfDate={issuer.reclameAquiRatings.asOfDate} isBrazilianIssuer={isBrazilianIssuer} />
            </div>
          </div>
        </div>
      </div>
    );
  }

  return null;
}

interface IRatingsAsOfDateProps {
  asOfDate: string;
  isBrazilianIssuer: boolean;
}

function RatingsAsOfDate({ asOfDate, isBrazilianIssuer }: IRatingsAsOfDateProps) {
  const parsedAsOfDate = parseDateYmd(asOfDate);
  const timeText = format(parsedAsOfDate, isBrazilianIssuer ? "d 'de' MMMM, yyyy" : "MMMM d, yyyy", {
    locale: isBrazilianIssuer ? ptBR : enUS,
  });

  return (
    <time
      className="text-xs font-normal italic tracking-wide text-slate-500"
      dateTime={parsedAsOfDate.toISOString()}
      title={lightFormat(parsedAsOfDate, "dd/MM/yyyy")}
    >
      {isBrazilianIssuer ? "Atualizado em" : "Updated on"} <strong>{timeText}</strong>
    </time>
  );
}

export default CompanyIssuerRatings;
